import React from 'react';

import useRouter from '../../../../../../hooks/useRouter';
import { StyledListItemProps } from '../StyledListItem';
import StyledLiWrapper from './StyledLiWrapper';

export type WithShareUrlProps = Partial<StyledListItemProps> & {
  shareUrl: string;
};

export type Source =
  | 'copy-link'
  | 'email'
  | 'facebook'
  | 'linkedin'
  | 'twitter'
  | 'whatsapp';

const withShareUrl = (
  ListItemButton: React.ComponentType<WithShareUrlProps>,
  source: Source
) => {
  return function Component({ ...rest }) {
    const router = useRouter();
    const shareUrl = React.useMemo(() => {
      const queryParams = new URLSearchParams({
        utm_source: source,
        utm_medium: 'share'
      }).toString();

      const pathName = router.asPathWithoutParams;

      return encodeURIComponent(
        `${process.env.NEXT_PUBLIC_CANONICAL_HOST}${pathName}?${queryParams}`
      );
    }, [router.asPathWithoutParams]);

    const sendAnalytics = React.useCallback(() => {
      if (window && window.dataLayer) {
        window.dataLayer.push({
          event: 'socialShare',
          socialCategory: 'social',
          socialAction: 'share',
          socialNetwork: source
        });
      }
    }, []);

    return (
      <StyledLiWrapper onClick={sendAnalytics}>
        <ListItemButton
          shareUrl={shareUrl}
          as='span'
          {...rest}
        />
      </StyledLiWrapper>
    );
  };
};

export default withShareUrl;
